import i18n from '@shared/i18n/index';
import { HttpDependency } from './dependency';

export const NOT_LOGIN_ERROR_CODE = '100007';

export const SERVICE_ERROR_CODE_MAP_MESSAGE: Record<string, string> = {
	20000: 'invalid path', // "路径错误"
	20001: 'unsupported error', // "不支持的操作"
	20002: 'version data error', // "版本数据异常"
	20003: 'permission verification failed', // "权限校验失败", "PERMISSION_VERIFICATION_FAILED"
	20100: 'file error', // "文件异常",  "FILE_ERROR"
	get 20203() {
		return i18n.get('Atomic_Error_Reason_ImageTooLarge');
	},
	70001: 'request error', //"请求异常" , "REQUEST_ERROR"
	200000: 'page error', // "分页错误"
	140000: 'Compute service error', //"计算服务异常", "COMPUTE_SERVICE_ERROR",
	150000: 'Big Data service error', // "大数据服务异常", "BIG_DATA_SERVICE_ERROR"
	160000: 'a1 service error', //"A1服务异常", "A1_SERVICE_ERROR"
	get 310000() {
		return i18n.get('Common_Ai_Service_Error_Toast');
	}, // "Ai服务请求失败", "AI_SERVICE_REQUEST_ERROR",
	310102: 'generate mask image error', // "模版图片生成失败", "GENERATE_MASK_IMAGE_ERROR"
	get 310205() {
		return i18n.get('MotionImitation_Mask_Toast');
	},
	321000: 'application usage create error', //"应用运行记录创建失败", "APP_USAGE_CREATE_ERROR"
	324000: 'create publication error', //  "创建发布异常", "CREATE_PUBLICATION_ERROR"
	324002: 'publish application error', //  "发布应用异常", "PUBLISH_APPLICATION_ERROR"
	326000: 'create topic error', //  "创建主题异常", "CREATE_TOPIC_ERROR"
	326100: 'create pub topic error', //  "创建应用主题异常", "CREATE_PUB_TOPIC_ERROR"
	326200: 'create img topic error', //  "创建美图主题异常", "CREATE_IMG_TOPIC_ERROR"
	325000: 'user statistic create error', //  "用户统计信息创建失败", "USER_STATISTIC_CREATE_ERROR"
	336000: 'image payment create error', //  "消费记录创建失败", "IMAGE_PAYMENT_CREATE_ERROR"
	336001: 'image payment update error', //  "消费记录更新失败", "IMAGE_PAYMENT_UPDATE_ERROR"
	331000: 'create application error', //  "创建应用异常", "CREATE_APPLICATION_ERROR"
	331001: 'update application error', //  "更新应用异常", "UPDATE_APPLICATION_ERROR"
	331007: 'application form data error', //  "应用表单数据异常", "APP_FORM_DATA_ERROR"
	333006: 'digital avatar training filed', //  "训练数字分身失败"
	333007: 'digital avatar state error', //  "数字分身状态异常"
	333009: 'digital avatar state error', //  "数字分身移除背景异常"
	333001: 'create image error', //  "创建美图异常", "CREATE_IMAGE_ERROR"
	333011: 'image optimize error', //  "图片精绘失败", "IMAGE_CAN_NOT_REPEAT_OPTIMIZE"
	333021: 'remove watermark error', //  "去除水印失败", "REMOVE_WATERMARK"
	3367003: 'label set error', //  "标签设置异常", "LABEL_SET_ERROR"
	334001: 'create model error', //  "创建模型异常", "CREATE_MODEL_ERROR"#
	334003: 'model audit fail', //  "模型审核失败", "AUDIT_FAIL"
	334004: 'civitai model fetch fail', //  "civitai模型拉取失败", "CIVITAI_FETCH_FAIL"
	// 334003: "model audit fail", //  "模型审核失败", "AUDIT_FAIL"
	// 334004: "civitai model fetch fail", //  "civitai模型拉取失败", "CIVITAI_FETCH_FAIL"
	335002: 'create style error', //  "创建风格异常", "CREATE_STYLE_ERROR"
	335003: 'sd version error', //  "sd版本异常", "SD_VERSION_ERROR"
	336002: 'create tag error', //  "创建标签失败，请重试", "CREATE_TAG_ERROR"
	336003: 'update tag error', //  "编辑标签失败，请重试", "UPDATE_TAG_ERROR"
	340000: 'translate error', //  "翻译失败", "TRANSLATE_ERROR"
	170000: 'Hitin service error', //  "Hitin服务异常", "HITIN_SERVICE_ERROR"
	get 180000() {
		return i18n.get('Commercial_PlanB_UseInfo_Code_810012');
	}, //  "Knute服务异常", "Knute_SERVICE_ERROR" 用户资产服务
	120000: 'User service error', //  "用户服务异常", "USER_SERVICE_ERROR"
	110005: 'Email send failed', //  "邮件发送失败", "FAILED_TO_SEND_MAIL"
	351000: 'create hitin advertisement record error', //  "创建广告记录异常", "CREATE_ADVERTISEMENT_RECORD_ERROR"
	341000: 'Create hitin version record error', //  "创建应用版本异常", "CREATE_VERSION_RECORD_ERROR"
	100003: 'Update user failed', //  "更新用户信息失败", "UPDATE_USER_FAILED"
	110010: 'Reset password error', //  "重置密码失败", "RESET_PASSWORD_ERROR"
	110011: 'Phone register error', //  "手机号注册失败", "PHONE_REGISTER_ERROR"
	110100: 'Google verify error', //  "google验证出错", "GOOGLE_VERIFY_ERROR"
	110102: 'google reCAPTCHA authenticate error', //  "人机验证出错", "GOOGLE_RECAPTCHA_VERIFICATION_ERROR"
	110201: 'Failed to generate the APIkey', //  "apiKey 生成失败", ""
};
export const BUSINESS_ERROR_CODE_MAP_MESSAGE: Record<string, string> = {
	get 100000() {
		return i18n.get('Login_User_NoExist_Toast');
	}, // "用户不存在"
	get 100001() {
		return i18n.get('Login_User_Already_Exist_Toast');
	}, // 用户已存在
	get 100018() {
		return i18n.get('Login_Email_NoRegister_Toast');
	},
	get 100013() {
		return i18n.get('Login_VerifyCode_Wrong_Toast');
	},
	get 100012() {
		return i18n.get('Login_VerifyCode_Wrong_Toast');
	},
	10000: 'invalid param', //  "参数错误"
	10001: 'query condition too large', // "查询条件过长"
	10406: 'Parameter is deprecated', // "已弃用的参数"
	20101: 'file suffix error', // "文件后缀异常", "FILE_SUFFIX_ERROR"
	20102: 'file upload too many', // "文件上传过多
	get 20201() {
		return i18n.get('Common_Image_Size_Large_Error_Toast');
	}, // "图片文件过大", "IMAGE_SIZE_TOO_LARGE"
	get 20203() {
		return i18n.get('Common_Image_Resolution_Large_Error_Toast', { number: 512 });
	}, // "图片分辨率太大", "IMAGE_RESOLUTION_TOO_LARGE"
	get 20204() {
		return i18n.get('Common_Image_Resolution_Small_Error_Toast', { number: 512 });
	}, // "图片分辨率太小", "IMAGE_RESOLUTION_TOO_SMALL"
	700102: 'activity has not started', // "活动还未开始", "ACTIVITY_NOT_STARTED"
	700103: 'activity has ended', //"活动已经结束", "ACTIVITY_ENDED"
	700104: 'invalid redemption code', //"兑换码错误", "INVALID_REDEMPTION_CODE"
	700105: 'code has been redeemed', //"兑换码已被使用", "CODE_ALREADY_REDEEMED"
	70002: 'Requests too frequent. Please try again later.', // "请求次数过多", "REQUESTS TOO FREQUENT"
	310101: 'unsupported control net', // "不支持的请求参数", "AI_SERVICE_UNSUPPORTED_CONTROL_NET"
	get 411003() {
		const { isPremiumVIP, isVIP } = HttpDependency.getIsVip();
		if (isVIP || isPremiumVIP) {
			return i18n.get('Common__BusyService_VIP_Toast');
		}
		return i18n.get('Common__BusyService_Toast');
	},
	get 310201() {
		return i18n.get('Common_Generate_Media_Error_Toast');
	},
	get 310202() {
		return i18n.get('Common_Content_Inappropriate');
	},
	322000: 'favorite create error', //"收藏创建失败", "FAVORITE_CREATE_ERROR"
	322001: 'favorite not exist', // "收藏不存在", "FAVORITE_NOT_EXIST"
	322002: 'favorite repeat', // "收藏重复", "ADD_FAVORITE_REPEAT"
	322003: 'cancel favorite repeat', // "取消收藏重复", "DELETE_FAVORITE_REPEAT"
	323000: 'like create error', //  "点赞创建失败", "LIKE_CREATE_ERROR"
	323001: 'like not exist', //  "点赞不存在", "LIKE_NOT_EXIST"
	323002: 'like repeat', //  "点赞重复", "ADD_LIKE_REPEAT"
	323003: 'cancel like repeat', //  "取消点赞重复", "DELETE_LIKE_REPEAT"
	// 324001: 'application not pass test', //  "应用未通过测试", "APP_NOT_PASS_TEST"
	get 324001() {
		return i18n.get('Build_BuildPage_NotTest_Toast');
	},
	324003: 'publish repeat', //  "重复发布", "PUBLISH_REPEAT"
	get 324004() {
		return i18n.get('Commercial_PlanB_UseInfo_Code_324012');
	}, //  "发布内容不存在", "PUBLICATION_NOT_EXIST"
	324005: 'publication is unpublished', //  "应用未上架", "PUBLICATION_IS_UNPUBLISHED"
	get 324006() {
		return i18n.get('App_Unvaliable_Toast');
	}, //  "应用不可用", "PUBLICATION_IS_UNAVAILABLE"
	324007: 'publication not contain sample image', //  "应用未包含封面图", "PUBLICATION_NO_SAMPLE_IMAGE"
	324008: 'publication need name', //  "需要填充应用名称", "PUBLICATION_NO_NAME"
	324009: 'publication top need recommended', //  "置顶需要推荐至广场", "PUBLICATION_NEED_RECOMMENDED"
	324010: 'This app does not support API access', // "此应用不支持通过API访问","APP_NO_SUPPORT_API" // 调用未发布应用、调用存在数字分身、wordart、合照组件的应用
	324011: 'The quantity must not exceed 4', //  "单个应用单次请求生图数量1～4张", "QUANTITY_EXCEED" // 单个应用单次请求生图数量1～4张，超过4张，调用失败
	324012: 'This app does not exist', //  "无效的应用ID", "APP_NOT_EXIST" // 无效的应用ID、app已删除
	324013: 'The application is updated. You need to obtain the application information again', //  "应用版本已更新，请重新获取应用信息", "NO_NEWEST_VERSION" // 应用版本更新后，调用报错，告知开发者需重新获取下应用信息
	326001: 'topic not exist', //  "主题不存在", "TOPIC_NOT_EXIST"
	326002: 'Topic not published', //  "专题未发布", "TOPIC_NOT_PUBLISHED"
	326101: 'create topic include unpublished pub app', //  "主题中包含未发布应用", "CREATE_PUB_TOPIC_INCLUDE_UNPUBLISHED"
	326201: 'create topic include unpublished img', //  "主题中包含未发布图片", "CREATE_IMG_TOPIC_INCLUDE_UNPUBLISHED"
	336002: 'image payment not exist', //  "消费记录不存在", "IMAGE_PAYMENT_NOT_EXIST"
	336003: 'image payment already success', //  "已经成功消费过了", "SUCCESS_IMAGE_PAYMENT_REPEAT"
	350000: 'Geographic location not obtained based on IP address', //"未根据IP地址获取地理位置", "REGION_NOT_OBTAINED_ON_IP")
	351000: 'Country group exist', //  "国家组已存在", "COUNTRY_GROUP_EXIST"
	351001: 'Country exist', //  "国家已存在", "COUNTRY_EXIST"
	331002: 'application not exist', //  "应用不存在", "APPLICATION_NOT_EXIST"
	331003: 'template not exist', //  "模板不存在", "TEMPLATE_NOT_EXIST"
	331004: "can't set template", //  "不能设置模板", "CAN_NOT_SET_TEMPLATE"
	331005: 'application id not match', //  "应用编号不匹配", "APP_ID_NOT_MATCH"
	331006: 'application can not delete', //  "应用禁止删除", "APP_CAN_NOT_DELETE"
	331008: 'fork application error', //  "复制应用失败", "FORK_APPLICATION_ERROR"
	332000: 'application version not exist', //  "应用版本不存在", "APPLICATION_VERSION_NOT_EXIST"
	332001: 'application version not released', //  "应用版本未发布", "APPLICATION_VERSION_NOT_RELEASE"
	332002: 'application version id not match', //  "版本编号不匹配", "APP_VERSION_ID_NOT_MATCH"
	333001: 'digital avatar not exist', //  "数字分身不存在", "DIGITAL_AVATAR_NOT_EXIST"
	333002: 'digital avatar has been used', //  "数字分身已经被使用", "DIGITAL_AVATAR_HAS_BEEN_USED"
	333003: 'digital avatar is training', //  "数字分身正在训练中", "DIGITAL_AVATAR_IS_TRAINING"
	333004: 'digital avatar is excessive quantity', //  "数字分身数量过多", "DIGITAL_AVATAR_EXCESSIVE_QUANTITY"
	333005: 'create digital avatar param is null', //  "创建数字分身参数为空"
	333006: 'image can not repeat publish', //  "图片禁止重复发布", "IMAGE_CAN_NOT_REPEAT_PUBLISH"
	get 333012() {
		// : 'image can not repeat optimize', //  "图片禁止重复精绘", "IMAGE_CAN_NOT_REPEAT_OPTIMIZE"
		return i18n.get('Image_EnhanceFailure_Toast');
	},
	333022: 'image already synced', //  "图片已同步", "IMAGE_ALREADY_SYNCED"
	3367001: 'label not exist', //  "标签不存在", "LABEL_NOT_EXIST"
	3367002: 'label exist', //  "标签已存在", "LABEL_EXIST"
	334002: 'model not exist', //  "模型不存在", "MODEL_NOT_EXIST"
	334005: 'The model has been added to the blacklist', //  "该模型已被加入黑名单", "MODEL_IN_BLACKLIST"
	334006: 'The model has been downloaded and is the latest version', //  "该模型已下载且为最新版本", "MODEL_DOWNLOADED"
	334101: 'model version not exist', //  "模型版本不存在", "MODEL_VERSION_NOT_EXIST"
	334102: 'model version downloaded', //  "模型版本已下载", "MODEL_VERSION_DOWNLOADED"
	335001: 'style not exist', //  "风格不存在", "STYLE_NOT_EXIST"
	336001: 'tag exist', //  "标签已存在，请勿重复创建", "TAG_EXIST"
	[NOT_LOGIN_ERROR_CODE]: 'User not login', //  "用户未登录", "USER_NOT_LOGIN"
	510000: 'Unsupported reward resource type', //  "暂不支持资源类型", "UNSUPPORTED_RESOURCE_TYPE"
	510001: 'Unsupported reward type', //  "暂不支持该奖励类型", "UNSUPPORTED_REWARD_TYPE"
	511000: 'Dealing error', //  "处理中，请刷新后重试", "DEAL_ERROR"
	512000: 'Reward cannot be grant repeatedly', //  "奖励不能重复发放", "REWARD_GRANT_REPEATEDLY"
	512001: 'Webhook userId is different from sessionUserId', //  "问卷填写用户与登陆用户不一致", "WEBHOOK_USER_DIFF"
	111000: 'Not agree post agreement', //  "未同意发布协议", "NOT_AGREE_POST_AGREEMENT"
	341001: 'This channel version already exists', //  "该渠道版本已存在", "CHANNEL_VERSION_EXIST"
	100002: 'User freeze', //  "用户已冻结", "USER_FREEZE"
	100004: 'User name is too long', //  "用户名过长", "USER_NAME_FAILED"
	100005: 'Name already exists', //  "用户名已存在", "USER_NAME_EXISTS"
	100006: 'User introduction is too long', //  "用户简介过长", "USER_INTRODUCE_FAILED"
	100008: 'No permission', //  "没有权限", "NO_PERMISSION"
	100009: 'User status not pass', //  "用户状态不通过", "USER_STATUS_CANNOT_PASS"
	110000: 'Per minute request rate limited', //  "每分钟只能请求一次", "MIN_REQ_EXCEEDS_LIMIT"
	110001: 'Request too frequently', //  "当天请求超过限制", "REQUEST_TOO_FREQUENTLY"
	110002: 'Verification code has expired', //  "验证码已过期", "INVALID_VERIFICATION_CODE"
	110003: 'Verification code error', //  "验证码错误", "INVALID_VERIFICATION_CODE"
	get 110004() {
		return i18n.get('Login_VerifyCode_Expire_Toast'); //  "验证码错误", "INVALID_VERIFICATION_CODE"
	},
	110006: 'Email used', //  "邮箱已被占用", "EMAIL_USED"
	110007: 'Google email used', //  "谷歌邮箱已被占用", "GOOGLE_EMAIL_USED"
	110008: 'Account has not registered', //  "账号未注册", "ACCOUNT_HAS_NOT_REGISTERED"
	get 110009() {
		return i18n.get('Login_Wrong_Toast'); //  "用户名或密码错误", "WRONG_ACCOUNT_OR_PASSWORD"
	},
	110012: 'phone params not exist', //  "手机号参数不存在", "PHONE_PARAMS_NOT_EXIST"
	110013: 'email params not exist', //  "手机号参数不存在", "EMAIL_PARAMS_NOT_EXIST"
	110014: 'Wrong verification code', //  "验证码错误", "WRONG_VERIFICATION_CODE"
	110101: 'google reCAPTCHA authenticate not pass', //  "人机验证未通过", "GOOGLE_RECAPTCHA_VERIFICATION_FAILED"
	110200: 'API key creation limit reached', //  "API 密钥创建数量已达上限", ""
	110202: 'invalid apiKey', //  "无效的apiKey", ""
	get 801014() {
		return i18n.get('Account_Logoff_Toast'); //  "账号已注销，无法登录"
	},
	get 800099() {
		return i18n.get('Commercial_Subscription_Restore_Toast');
	},
	get 800100() {
		return i18n.get('Commercial_Graceperiod_Payment_Crossplatform');
	},
	get 310206() {
		return i18n.get('Common_Image_Resolution_Faild_HD');
	},
	get 310207() {
		return i18n.get('Common_Image_Resolution_Faild_FHD');
	},
};

export const getErrorMessage = (code?: number) => {
	if (!code) return '';
	return SERVICE_ERROR_CODE_MAP_MESSAGE[code] || BUSINESS_ERROR_CODE_MAP_MESSAGE[code] || '';
};
